import { render, staticRenderFns } from "./premium-feature-gate.vue?vue&type=template&id=02add647&scoped=true&"
import script from "./premium-feature-gate.vue?vue&type=script&lang=js&"
export * from "./premium-feature-gate.vue?vue&type=script&lang=js&"
import style0 from "./premium-feature-gate.vue?vue&type=style&index=0&id=02add647&prod&lang=scss&"
import style1 from "./premium-feature-gate.vue?vue&type=style&index=1&id=02add647&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02add647",
  null
  
)

export default component.exports